import React from 'react'

//* Translations
import { TRANSLATIONS } from 'pages/BusinessHome/utilities';
import { getTranslation } from 'translations/index';

// Styles
import styles from './BannerCompanies.module.scss';

const BannerCompanies = () => {
    
  const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();

  return (
    <div className={styles["banner-companies"]}>
        <div className={styles["content-container"]}>
            <h2 className={styles['title']}>{getTranslation(TRANSLATIONS, LANG, "companies_banner_title")}</h2>
            <img src="https://filotrack.com/wp-content/uploads/Business_Brands-1024x47.png" alt="" className={styles["banner-img"]} />
        </div>
    </div>
  )
}

export default BannerCompanies